// Helper function to check if value is still a placeholder
const isPlaceholder = (value) => {
  return typeof value === 'string' && value.startsWith('%') && value.endsWith('%');
};

export const getEnvName = () => {
  if (typeof window !== "undefined" && window._env_ && window._env_.ENV_NAME && !isPlaceholder(window._env_.ENV_NAME)) {
    return window._env_.ENV_NAME;
  }
  return process.env.REACT_APP_ENV_NAME;
};

export const getBackendUrl = () => {
  if (typeof window !== "undefined" && window._env_ && window._env_.BACKEND_URL && !isPlaceholder(window._env_.BACKEND_URL)) {
    return window._env_.BACKEND_URL;
  }
  return process.env.REACT_APP_JAVA_API_URL;
};

export const getPythonApiUrl = () => {
  if (typeof window !== "undefined" && window._env_ && window._env_.PYTHON_API_URL && !isPlaceholder(window._env_.PYTHON_API_URL)) {
    return window._env_.PYTHON_API_URL;
  }
  return process.env.REACT_APP_PYTHON_API_URL;
};

export const getPublicPosthogUrl = () => {
  if (typeof window !== "undefined" && window._env_ && window._env_.PUBLIC_POSTHOG_URL && !isPlaceholder(window._env_.PUBLIC_POSTHOG_URL)) {
    return window._env_.PUBLIC_POSTHOG_URL;
  }
  return process.env.REACT_APP_PUBLIC_POSTHOG_HOST;
};

export const getPublicPosthogKey = () => {
  if (typeof window !== "undefined" && window._env_ && window._env_.PUBLIC_POSTHOG_KEY && !isPlaceholder(window._env_.PUBLIC_POSTHOG_KEY)) {
    return window._env_.PUBLIC_POSTHOG_KEY;
  }
  return process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
};